export const origemOptions = [
  { title: 'Bot Cliente', value: '0' },
  { title: 'Telemarketing', value: '1' },
  { title: 'Site PG', value: '2' },
  { title: 'Aplicativo', value: '3' },
  { title: 'Whatsapp', value: '4' },
  { title: 'Entrega do Gás', value: '6' },
  { title: 'Botijão de Gás', value: '7' },
  { title: 'Botijão Vazio', value: '8' },
  { title: 'Comprar gás de cozinha', value: '9' },
  { title: 'Tel Ultra', value: '10' },
  { title: 'Tel Super', value: '11' },
  { title: 'Distribuidores', value: '12' },
  { title: 'Botijão', value: '13' },
  { title: 'Refeito', value: '14' },
  { title: 'Aplicativo Novo', value: '16' },
  { title: 'App Apple', value: '17' },
  { title: 'App 99 iOS', value: '98' },
  { title: 'App 99 Android', value: '99' },
]

export const estadosOptions = [
  { title: 'Acre', value: 'AC' },
  { title: 'Alagoas', value: 'AL' },
  { title: 'Amapá', value: 'AP' },
  { title: 'Amazonas', value: 'AM' },
  { title: 'Bahia', value: 'BA' },
  { title: 'Ceará', value: 'CE' },
  { title: 'Distrito Federal', value: 'DF' },
  { title: 'Espírito Santo', value: 'ES' },
  { title: 'Goiás', value: 'GO' },
  { title: 'Maranhão', value: 'MA' },
  { title: 'Mato Grosso', value: 'MT' },
  { title: 'Mato Grosso do Sul', value: 'MS' },
  { title: 'Minas Gerais', value: 'MG' },
  { title: 'Pará', value: 'PA' },
  { title: 'Paraíba', value: 'PB' },
  { title: 'Paraná', value: 'PR' },
  { title: 'Pernambuco', value: 'PE' },
  { title: 'Piauí', value: 'PI' },
  { title: 'Rio de Janeiro', value: 'RJ' },
  { title: 'Rio Grande do Norte', value: 'RN' },
  { title: 'Rio Grande do Sul', value: 'RS' },
  { title: 'Rondônia', value: 'RO' },
  { title: 'Roraima', value: 'RR' },
  { title: 'Santa Catarina', value: 'SC' },
  { title: 'São Paulo', value: 'SP' },
  { title: 'Sergipe', value: 'SE' },
  { title: 'Tocantins', value: 'TO' },
]

export const categoriaProdutoOptions = [
  { title: 'Todos', value: null },
  { title: 'Gás', value: 'GAS' },
  { title: 'Água', value: 'AGUA' },
]
